import React from "react";

import {
  FileCad,
  FileCameo,
  FileDefault,
  FileDoc,
  FileJpg,
  FileJson,
  FileMatlab,
  FilePng,
  FileXls,
  FileXml,
} from "~/assets/svg";

const getFileSVGIconByExtension = (extension: string): React.JSX.Element => {
  const loweredcaseExtension = extension.toLowerCase();
  switch (loweredcaseExtension) {
    case "catpart":
    case "catproduct":
      return <FileCad data-testid="cad-svg-icon" width="30px" height="30px" />;
    case "docx":
      return <FileDoc data-testid="docx-svg-icon" width="30px" height="30px" />;
    case "jpg":
    case "jpeg":
      return <FileJpg data-testid="jpg-svg-icon" width="30px" height="30px" />;
    case "json":
      return <FileJson data-testid="json-svg-icon" width="30px" height="30px" />;
    case "m":
      return <FileMatlab data-testid="matlab-svg-icon" width="30px" height="30px" />;
    case "mdzip":
      return <FileCameo data-testid="cameo-svg-icon" width="30px" height="30px" />;
    case "png":
      return <FilePng data-testid="png-svg-icon" width="30px" height="30px" />;
    case "xml":
      return <FileXml data-testid="xml-svg-icon" width="30px" height="30px" />;
    case "xlsx":
      return <FileXls data-testid="xlsx-svg-icon" width="30px" height="30px" />;
    default:
      return <FileDefault data-testid="default-file-svg-icon" width="30px" height="30px" />;
  }
};

export default getFileSVGIconByExtension;
